<section class="px-lg md:px-6xl text-center flex flex-col items-center">
  <div class="hero flex flex-col items-center">
    <h1
      class="font-bold text-heading-4 md:text-display-lg mb-sm md:mb-2xl mt-7xl">
      {{ 'landing_page_hero_section_title_part_one' | transloco }}

      <span
        class="bg-linear-to-r from-supplier-500 to-buyer-500 bg-clip-text text-transparent">
        {{ 'landing_page_hero_section_title_part_two' | transloco }}
      </span>
    </h1>

    <p class="text-neutral-700 text-medium md:text-large">
      {{ 'landing_page_hero_section_subtitle' | transloco }}
    </p>
  </div>

  <div class="dashboard-img-container ltr">
    @if (branding.dashboardImage(); as src) {
      <!-- The replica's own screenshot (images.dashboard) — one URL, no srcset. -->
      <img
        [src]="src"
        alt="dashboard"
        fetchpriority="high"
        loading="eager"
        decoding="sync" />
    } @else {
      <img
        src="/assets/images/landing/dashboard-xl.webp"
        alt="dashboard"
        fetchpriority="high"
        loading="eager"
        decoding="sync"
        srcset="
          /assets/images/landing/dashboard-sm.webp  440w,
          /assets/images/landing/dashboard-lg.webp 1024w,
          /assets/images/landing/dashboard-xl.webp 1440w
        " />
    }
  </div>
</section>
